import { Injectable } from '@angular/core';

class WebStorageService {

  constructor(private storage: Storage) {}

  get(key: string): any {
    return this.storage.getItem(key);
  }

  set(key: string, value: any): void {
    this.storage.setItem(key, value);
  }

  remove(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }
}

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService extends WebStorageService {
  constructor() {
    super(localStorage);
  }
}

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService extends WebStorageService {
  constructor() {
    super(sessionStorage);
  }
}
